
















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import attendeeSearchVuexModule from "@/store/vuex-modules/searchAttendeeData";
import states from "@/assets/dictionaries/state-list.ts";
import Spinners from "@/components/utilities/Spinners.vue";

declare module "@/assets/dictionaries/state-list.ts";

const attendeeSearchStore = getModule(attendeeSearchVuexModule);

@Component({
    components: {
        Spinners,
    },
})
export default class AttendeeSearchForm extends Vue {
    @Prop({ default: "" })
    profileOwnerId!: string;

    isLoading = false;
    states = states;
    searchString = "";
    // formFields: AttendeeSearchFormFields = {
    // 	firstName: '',
    // 	lastName: '',
    // 	companyName: '',
    // 	state: '',
    // 	lookingNetwork: false,
    // 	lookingCollab: false,
    // 	lookingHiring: false,
    // 	lookingTech: false,
    // 	lookingResearch: false,
    // 	lookingLeadership: false,
    // 	lookingEmployment: false,
    // };

    // get fullName() {
    // 	// TODO: If we have both first and last name search fields, it should also be separate fields in the database
    // 	return [this.formFields.firstName, this.formFields.lastName]
    // 		.filter((name) => name)
    // 		.join(' AND ');
    // }

    submitForm() {
        if (!this.searchString) {
            return;
        }

        this.isLoading = true;

        const searchString = this.searchString;
        attendeeSearchStore
            .searchAttendees(searchString)
            .then(() => {
                this.$router.push("/attendees/results");
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    clearForm() {
        // this.formFields = {
        // 	firstName: '',
        // 	lastName: '',
        // 	companyName: '',
        // 	state: 'State',
        // 	lookingNetwork: false,
        // 	lookingCollab: false,
        // 	lookingHiring: false,
        // 	lookingTech: false,
        // 	lookingResearch: false,
        // 	lookingLeadership: false,
        // 	lookingEmployment: false,
        // };
        this.searchString = "";
    }
}
